module.exports = __webpack_public_path__ + "c15cc73f33ae01ac0558975b3f13d882.pdf";